export default __webpack_public_path__ + "static/media/photosAdultRight.d747c05a.webp";